// src/components/services/ServicePageCTA.js
import React from 'react';
import { Link } from 'react-router-dom';
import './ServicePageCTA.css';

function ServicePageCTA() {
  return (
    <section className="service-page-cta-container">
      {/* Contenu textuel et boutons au-dessus des formes animées */}
      <div className="cta-content-wrapper">
        <h2>
          Prêt à <span className="highlight-cta-text">donner vie</span> à votre projet web ?
        </h2>
        <p>
          Notre équipe d'experts est prête à vous accompagner et à transformer vos idées en solutions numériques performantes.
          Contactez-nous dès aujourd'hui pour discuter de vos besoins et obtenir un devis personnalisé.
        </p>
        <div className="cta-buttons-wrapper"> {/* Wrapper pour les boutons */}
          <Link to="/contact" className="btn btn-primary btn-cta-main">
            Demander un devis gratuit <span className="cta-icon" aria-hidden="true">&rarr;</span>
          </Link>
          <Link to="/realisations" className="btn btn-outline-light btn-cta-secondary">
            Voir nos projets <span className="cta-icon" aria-hidden="true">✨</span>
          </Link> 
        </div>
      </div>
      {/* Formes animées pour l'arrière-plan */}
      <div className="cta-bg-shapes">
        <div className="s-shape s-shape1"></div>
        <div className="s-shape s-shape2"></div>
        <div className="s-shape s-shape3"></div>
      </div>
    </section>
  );
}

export default ServicePageCTA;